import React from "react";
import { Platform, View } from "react-native";
import {
  Text,
  useResponsive,
  Panel,
  Heading,
  Icon,
} from "@clearabee/ui-library-native";
import { styles } from "./ProductDetails.styles";
import { ProhibitedItem } from "lib/helpers/tooltipHelper";
import { useTranslation } from "react-i18next";
import { PROHIBITED_ITEMS } from "lib/constants/prohibitedItems";
import { Anchor } from "components/Core/Anchor/Anchor";
import { UseTooltipReturn } from "lib/hooks/useTooltip";
import { getEnv } from "lib/getEnv";

interface ProhibitedItemsPanelProps {
  surchargeItems?: UseTooltipReturn["surchargeItems"];
  prohibitedItems?: UseTooltipReturn["prohibitedItems"];
  hasSurcharges?: boolean;
}

export const ProhibitedItemsPanel = ({
  hasSurcharges = false,
  surchargeItems = [],
  prohibitedItems = [],
}: ProhibitedItemsPanelProps): React.ReactElement => {
  const { screens } = useResponsive();
  const [translate] = useTranslation();

  return (
    <Panel
      color="warning"
      shadow={Platform.OS === "web"}
      styles={[
        {
          padding: 0,
          flex: 1,
          justifyContent: "space-between",
        },
        screens.medium &&
          hasSurcharges && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
      ]}
    >
      {!!surchargeItems.length && !prohibitedItems.length && screens.large && (
        <View style={styles.overlay} />
      )}
      <Heading
        fontSize="base"
        color="greyscale"
        styles={styles.prohibitedItemsHeading}
      >
        {translate("hwa.screens.productDetails.prohibitedItems.heading")}
      </Heading>

      {(Object.keys(PROHIBITED_ITEMS) as ProhibitedItem[]).map((item) => (
        <View
          key={item}
          style={[
            styles.prohibitedItem,
            prohibitedItems.includes(item) &&
              screens.large &&
              styles.selectedProhibitedItem,
          ]}
        >
          <View
            style={[
              styles.prohibitedIcon,
              prohibitedItems.includes(item) &&
                screens.large &&
                styles.selectedProhibitedIcon,
            ]}
          >
            <Icon.Close
              width={10}
              height={10}
              color={
                prohibitedItems.includes(item) && screens.large
                  ? "negative"
                  : "light"
              }
            />
          </View>
          <Text
            color={
              prohibitedItems.includes(item) && screens.large
                ? "light"
                : "greyscale"
            }
          >
            {translate(
              `hwa.screens.productDetails.prohibitedItems.list.${item}`,
            )}
          </Text>
        </View>
      ))}

      <View style={styles.contactUsPanel}>
        <Text>
          <Anchor
            routeName="Redirect"
            params={{
              url: `${getEnv("WEBSITE_URL")}/contact`,
            }}
            newTab
          >
            <Text
              styles={[
                { fontFamily: "ProximaSemiBold" },
                Platform.select({
                  default: {},
                  ios: { marginBottom: -2 },
                  android: { marginBottom: -5 },
                }),
              ]}
              color="warning"
            >
              {translate("common.contactUs")}
            </Text>
          </Anchor>
          <Text color="warning">
            {" "}
            {translate("hwa.screens.productDetails.prohibitedItems.message")}
          </Text>
        </Text>
      </View>
    </Panel>
  );
};
